<template>
    <div class="upload-file">
      <el-upload
        multiple
        class="upload-file-uploader"
        :before-upload="handleBeforeUpload"
        :http-request="httpRequest"
        :file-list="fileList"
        :limit="limit"
        :on-error="handleUploadError"
        :on-exceed="handleExceed"
        :show-file-list="false"
        ref="upload"
      >
        <!-- <el-icon class="avatar-uploader-icon"><plus /></el-icon> -->
        <el-button type="primary">选取文件</el-button>
      </el-upload>
      <!-- 上传提示 -->
      <div class="el-upload__tip" v-if="!file.name">
        请上传
        <template v-if="fileSize"> 大小不超过 <b style="color: #f56c6c">{{ fileSize }}MB</b> </template>
        <template v-if="fileType"> 格式为 <b style="color: #f56c6c">{{ fileType.join("/") }}</b> </template>
        的文件
      </div>
      <!-- 文件列表 -->
      <transition-group class="upload-file-list el-upload-list el-upload-list--text" name="el-fade-in-linear" tag="ul" v-if="file.name">
        <li class="el-upload-list__item ele-upload-list__item-content">
          <span class="el-icon-document"> {{ file.name }} </span>
          <el-link :underline="false" @click="previewVideo(file.videoId)">
            <el-icon><View /></el-icon>
            查看
          </el-link>
        </li>
      </transition-group>
    </div>
  </template>
  
  <script setup>
  import { ref,reactive,getCurrentInstance,computed,watch } from 'vue'
  import {getVideoToken} from "../../server/jigou/org";
  import * as qiniu from "qiniu-js";
  import { useStore } from 'vuex'
  import { useRouter } from 'vue-router'
  import { getUserInfo } from "../../server/user_center_info";
  const store = useStore()
  const router = useRouter();
  
  const props = defineProps({
    modelValue: [String, Object, Array],
    // 图片数量限制
    limit: {
      type: Number,
      default: 1,
    },
    // 大小限制(MB)
    fileSize: {
      type: Number,
      default: 4096,
    },
    // 大小限制(MB)
    // 文件类型, 例如['png', 'jpg', 'jpeg']
    fileType: {
      type: Array,
      default: () => ["mp4"],
    },
    // 是否显示提示
    isShowTip: {
      type: Boolean,
      default: true
    },
  });
  
  // 视频预览
  const previewVideo = (id) => {
    let routerJump = router.resolve({
      path: "/organization/previewVideo",
      query: {
        id
      }
    });
    window.open(routerJump.href, '_blank');
  };
  
  const { proxy } = getCurrentInstance();
  const upload = ref(null);
  const emit = defineEmits();
  const number = ref(0);
  const uploadList = ref([]);
  const dialogImageUrl = ref("");
  const dialogVisible = ref(false);
  const fileList = ref([]);
  const file = ref({});
  const showTip = computed(
    () => props.isShowTip && (props.fileType)
  );
watch(() => props.modelValue, val => {
  // console.log("watch:model", val)
  if (val){
    file.value = Object.assign({}, val);
  }
  return;
},{ deep: true, immediate: true });
  
  // 上传成功回调
  function handleUploadSuccess(res) {
    uploadList.value.push(res);
    if (uploadList.value.length === number.value) {
      file.value = res;
      console.log(file.value);
      uploadList.value = [];
      number.value = 0;
      emit("videoUploadSuccess", listToString(file.value));
      proxy.$modal.closeLoading();
    }
  }
  
  async function httpRequest(file) {
    // 获取签名
    let res = await getVideoToken()
    if( res != false ){
        var keyPrefix = "classroom/" + store.state.userCenterInfo.accountInfo.userId + "/",
          videoData = {
            name: file.file.name.split(".mp4")[0],
            duration: 0,
          };
  
         //获取视频时长
        var audioElement = new Audio(URL.createObjectURL(file.file));
        audioElement.addEventListener("loadedmetadata", function (_event) {
            videoData.duration = Math.round(audioElement.duration);
        });
      
      // https://developer.qiniu.com/kodo/1283/javascript
      const token = res.token,
          key = keyPrefix + file.file.name,
          putExtra = {
            fname: file.name,
          },
          config = {
            useCdnDomain: true,
            region: res.region
          };
      let observer = {
        next (res) {
          console.log(res)
          console.log('已上传大小，单位为字节：' + res.total.loaded)
          console.log('本次上传的总量控制信息，单位为字节：' + res.total.size)
          console.log('当前上传进度，范围：0～100：' + res.total.percent);
        },
        error (err) {
          console.log(err)
          console.log(err.code)
          console.log(err.message)
          console.log(err.isRequestError)
          console.log(err.reqId)
        },
        complete (res) {
          videoData.videoUrl = res.data.url;
          videoData.videoId = res.data.id;
          handleUploadSuccess(videoData);
        }
      };
  
      const observable = qiniu.upload(file.file, key, token, putExtra, config)
      const subscription = observable.subscribe(observer) // 上传开始
      console.log(subscription);
    }
  }
  
  // 上传前loading加载
  function handleBeforeUpload(file) {
    console.log('handleBeforeUpload')
    // 校检文件类型
    if (props.fileType.length) {
      let fileExtension = "";
      if (file.name.lastIndexOf(".") > -1) {
        fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
      }
      const isTypeOk = props.fileType.some((type) => {
        if (file.type.indexOf(type) > -1) return true;
        if (fileExtension && fileExtension.indexOf(type) > -1) return true;
        return false;
      });
      if (!isTypeOk) {
        proxy.$modal.msgError(`文件格式不正确, 请上传${props.fileType.join("/")}格式文件!`);
        return false;
      }
    }
    // 校检文件大小
    if (props.fileSize) {
      const isLt = file.size / 1024 / 1024 < props.fileSize;
      if (!isLt) {
        proxy.$modal.msgError(`上传文件大小不能超过 ${props.fileSize} MB!`);
        return false;
      }
    }
    proxy.$modal.loading("正在上传文件，请稍候...");
    number.value++;
    return true;
  }
  
  // 文件个数超出
  function handleExceed(files) {
    console.log("handleExceed", files, upload)
    upload.value.clearFiles()
    const file = files[0]
    file.file = file
  
    // upload.value.submit()
    handleBeforeUpload(file);
    httpRequest(file)
    // proxy.$modal.msgError(`上传文件数量不能超过 ${props.limit} 个!`);
  }
  
  // 上传失败
  function handleUploadError() {
    proxy.$modal.msgError("上传图片失败");
    proxy.$modal.closeLoading();
  }
  
  // 对象转成指定字符串分隔
  function listToString(list, separator) {
    return list;
  }
  </script>
  
  <style scoped>
  /* // .el-upload--picture-card 控制加号部分
  :deep(.hide .el-upload--picture-card) {
      display: none;
  } */

  .el-icon-document{
    width: 180px;
    white-space: nowrap;
    overflow: hidden;
  }
  </style>
  